<template>
  <div class="white">
    <vetalfa-ads class="px-2"></vetalfa-ads>
    <vetalfa-section-title
      v-if="veterinary_products.length"
      :prop="labels.VETERINARY_PRODUCTS"
    >
      <div
        v-for="(productsKey, index) in veterinaryProductsMap"
        :key="index + 'vetPresentation' + productsKey[0].presentation"
        v-bind:id="'vet' + _createIdentifier(productsKey[0].presentation)"
      >
        <vetalfa-section-item-title :prop="productsKey[0].presentation">
          <vetalfa-product-card
            v-for="(product, index) in productsKey"
            :isDrugsManagement="isDrugsManagement"
            :key="index + 'vetName' + product.name"
            :product="product"
          ></vetalfa-product-card>
        </vetalfa-section-item-title>
      </div>
    </vetalfa-section-title>
    <vetalfa-section-title
      v-if="human_products.length"
      :prop="labels.HUMAN_PRODUCTS"
    >
      <vetalfa-section-item-title
        v-for="(presentationKey, index) in humanProductsMap"
        :key="index + 'humPresentation' + presentationKey.presentation"
        :prop="presentationKey.presentation"
        v-bind:id="'hum' + _createIdentifier(presentationKey.presentation)"
      >
        <div
          v-for="(presentation, index) in presentationKey"
          :key="index + 'humDiv' + presentation"
        >
          <div v-if="presentation != presentationKey.presentation">
            <vetalfa-section-item
              :index="getObjectIndexFromVolume(presentationKey, presentation)"
              :prop="presentation.volume"
            >
              <div
                v-for="(product, index) in presentation.products"
                :key="`${product}${index}volumes-and-products`"
              >
                <vetalfa-section-sub-item
                  v-if="!product.includes(parameters.GENERIC_HUMAN_PRODUCT)"
                  :prop="product.trim()"
                ></vetalfa-section-sub-item>
              </div>
            </vetalfa-section-item>
          </div>
        </div>
      </vetalfa-section-item-title>
    </vetalfa-section-title>
    <div style="height: 30px; background-color: white"></div>
  </div>
</template>

<style>
</style>

<script>
import products from "@/constants/products.enum.js";
import labels from "@/constants/labels.js";
import parameters from "@/constants/parameters.js";
import {} from "@mdi/js";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ProductsTab",
  computed: {
    ...mapGetters("drugs", ["veterinaryProductsMap", "humanProductsMap"]),
  },
  props: {
    veterinary_products: {
      type: Array,
    },
    human_products: {
      type: Array,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapMutations("drugs", [
      "setVeterinaryProductsMap",
      "setHumanProductsMap",
    ]),
    getObjectIndexFromVolume(object, property) {
      let i = -1;
      for (var prop in object) {
        if (prop == property.volume) {
          return i;
        }
        i++;
      }
      return undefined;
    },
  },
  data() {
    return {
      products,
      labels,
      parameters,
    };
  },
  created() {},
};
</script>